import type { FiltroDef } from "../types";

/**
 * BARRA DE FILTROS das listagens.
 *
 * Um seletor por filtro, ao lado da busca. As opções vêm da configuração da
 * aba (src/config.ts) — nunca dos dados: num campo que guarda LISTA (como o
 * tipo de análise, que pode ter FQ e CR juntas), deduzir dos dados criaria a
 * opção "fisicoQuimica,pcb".
 *
 * Fica no NÍVEL DO ARQUIVO de propósito: componente declarado dentro de outro
 * vira função nova a cada tecla e o React remonta a tela inteira (o campo perde
 * o foco e a rolagem pula). Já aconteceu neste monorepo.
 */
export default function FiltrosBarra({
  filtros,
  valores,
  onChange,
}: {
  filtros: FiltroDef[];
  valores: Record<string, string>;
  onChange: (campo: string, valor: string) => void;
}) {
  if (filtros.length === 0) return null;

  const algumAtivo = filtros.some((f) => (valores[f.campo] ?? "") !== "");

  return (
    <div className="crud-filtros">
      {filtros.map((f) => (
        <label key={f.campo} className="crud-filtro">
          <span>{f.label}</span>
          <select
            className="crud-select"
            value={valores[f.campo] ?? ""}
            onChange={(e) => onChange(f.campo, e.target.value)}
          >
            <option value="">{f.vazioLabel ?? "Todos"}</option>
            {f.opcoes.map((o) => (
              <option key={o.valor} value={o.valor}>
                {o.rotulo}
              </option>
            ))}
          </select>
        </label>
      ))}
      {algumAtivo && (
        <button
          type="button"
          className="btn-secondary btn-sm"
          onClick={() => filtros.forEach((f) => onChange(f.campo, ""))}
        >
          Limpar filtros
        </button>
      )}
    </div>
  );
}
